import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import {
  INPUT_BORDERS_COLOR,
  SILVER,
  SOLITUDE,
  FONT_FAMILY_MAIN,
  TEXT_COLOR,
  MAIN_BLUE,
  COBALT,
  INPUT_BORDERS_COLOR_ERROR,
} from '@espacePro/constants/admin-theme';

const matchOptionColor = ({ isDisabled, isFocused, isSelected }) => {
  if (isDisabled) {
    return null;
  }
  if (isSelected) {
    return MAIN_BLUE;
  }
  if (isFocused) {
    return 'rgb(74, 144, 226, 0.2)';
  }
  return null;
};

const selectStyles = {
  control: (styles, { selectProps: { hasError } }) => ({
    ...styles,
    backgroundColor: SOLITUDE,
    borderRadius: '4px',
    borderColor: hasError ? INPUT_BORDERS_COLOR_ERROR : INPUT_BORDERS_COLOR,
    padding: '4px 4px 4px 8px',
    fontFamily: FONT_FAMILY_MAIN,
    minHeight: '48px',
    fontSize: '16px',
  }),
  input: (styles) => ({
    ...styles,
    fontSize: '16px',
    color: TEXT_COLOR,
    fontFamily: FONT_FAMILY_MAIN,
  }),
  placeholder: (styles) => ({
    ...styles,
    color: SILVER,
    fontFamily: FONT_FAMILY_MAIN,
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: MAIN_BLUE,
    color: '#fff',
    padding: 0,
    borderRadius: '4px',
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: '#fff',
    fontFamily: FONT_FAMILY_MAIN,
    padding: '4px 4px 4px 6px',
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    borderRadius: '0 4px 4px 0',
    ':hover': {
      backgroundColor: COBALT,
      color: '#fff',
    },
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: 0,
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: matchOptionColor({ isDisabled, isFocused, isSelected }),
    ':active': {
      ...styles[':active'],
      backgroundColor: MAIN_BLUE,
      color: '#fff',
    },
  }),
};

const CustomReactSelect = ({
  placeholder,
  onChange,
  options,
  defaultValue,
  hasError,
  inputBackgroundColor,
  ...props
}) => {
  const customStyles = {
    ...selectStyles,
    control: (base, state) => ({
      ...selectStyles.control(base, state),
      backgroundColor: inputBackgroundColor,
    }),
  };
  return (
    <Select
      placeholder={placeholder}
      onChange={onChange}
      options={options}
      styles={customStyles}
      noOptionsMessage={() => "Pas d'autre option disponible"}
      loadingMessage={() => 'Chargement'}
      defaultValue={defaultValue}
      hasError={hasError}
      inputBackgroundColor={inputBackgroundColor}
      {...props}
    />
  );
};

CustomReactSelect.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      value: PropTypes.string,
    }),
  ).isRequired,
  defaultValue: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      value: PropTypes.string,
    }),
  ),
  hasError: PropTypes.bool,
  inputBackgroundColor: PropTypes.string,
};

CustomReactSelect.defaultProps = {
  placeholder: '',
  defaultValue: [],
  hasError: false,
  inputBackgroundColor: SOLITUDE,
};

export { CustomReactSelect };
